import Header from "../../Common/header";
import Footer from "../../Common/footer";
import useDocumentTitle from "../../Common/useDocumentTitle";


/**
 * Returns the Frequently Asked Questions page component.
 * 
 * @returns The Frequently Asked Questions page component.
 */
const FAQ = () => {
  useDocumentTitle("FAQ");
  return (
    <>
      <Header />

      <div className="bg-white">
        <div className="max-w-7xl mx-auto py-12 px-4 divide-y divide-gray-200 sm:px-6 lg:py-16 lg:px-8">
          <h2 className="text-3xl tracking-tight font-bold text-gray-900">Frequently asked questions</h2>

          <div className="mt-8">
            <dl className="divide-y divide-gray-200">

              <div className="pt-6 pb-8 md:grid md:grid-cols-12 md:gap-8">
                <dt className="text-base font-medium text-gray-900 md:col-span-5">Do I need to sign up or login to view the available datasets?</dt>

                <dd className="mt-2 md:mt-0 md:col-span-7">
                  <p className="text-base text-gray-500">No, you can explore the data catalogue page without signing up.</p>
                </dd>
              </div>

              <div className="pt-6 pb-8 md:grid md:grid-cols-12 md:gap-8">
                <dt className="text-base font-medium text-gray-900 md:col-span-5">Who is a contributor?</dt>

                <dd className="mt-2 md:mt-0 md:col-span-7">
                  <p className="text-base text-gray-500">A contributor is a verified user, who is able to submit datasets to the Arctic Research Foundation Database.</p>
                </dd>
              </div>

              <div className="pt-6 pb-8 md:grid md:grid-cols-12 md:gap-8">
                <dt className="text-base font-medium text-gray-900 md:col-span-5">How can I become a contributor?</dt>

                <dd className="mt-2 md:mt-0 md:col-span-7">
                  <p className="text-base text-gray-500">To become a contributor, you must create an account and request contributor verification on the profile page in the 'Contributor Status' section.</p>
                </dd>
              </div>

              <div className="pt-6 pb-8 md:grid md:grid-cols-12 md:gap-8">
                <dt className="text-base font-medium text-gray-900 md:col-span-5">How do I submit a dataset?</dt>

                <dd className="mt-2 md:mt-0 md:col-span-7">
                  <p className="text-base text-gray-500">To submit a dataset, first, you must create an account and request contributor verification. Once your account is approved, you will be able to submit datasets. Note that each submission must be approved by our team before it is visible to the public.</p>
                </dd>
              </div>


              <div className="pt-6 pb-8 md:grid md:grid-cols-12 md:gap-8">
                <dt className="text-base font-medium text-gray-900 md:col-span-5">How long do I wait to get verified to be a contributor?</dt>

                <dd className="mt-2 md:mt-0 md:col-span-7">
                  <p className="text-base text-gray-500">Within 24 - 72 hours.</p>
                </dd>
              </div>


              <div className="pt-6 pb-8 md:grid md:grid-cols-12 md:gap-8">
                <dt className="text-base font-medium text-gray-900 md:col-span-5">What can I do if I'm not able to submit a project after I became a contributor?</dt>

                <dd className="mt-2 md:mt-0 md:col-span-7">
                  <p className="text-base text-gray-500">Use the contact us page to send a brief description of the issue and wait for assistance.</p>
                </dd>
              </div>

            </dl>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default FAQ;